<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-xl-6">
                        <label>
                            <i class="fa fa-check-circle"></i>
                            <b> Cliente</b>
                        </label>
                        <p v-if="objPedido.cliente != null">{{ objPedido.cliente.Nombre }}</p>
                    </div>
                    <div class="col-12 col-xl-6">
                        <label>
                            <i class="fa fa-check-circle"></i>
                            <b> Paciente</b>
                        </label>
                        <p>{{ objPedido.Paciente }}</p>
                    </div>
                    <hr style="background-color: grey;">
                </div>

                <template v-if="parseInt(objPedido.tipolente.Proceso) == 1">
                    <div class="row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Tipo de lente</b>
                            </label>
                            <p v-if="objPedido.tipolente !== null" style="text-transform: uppercase;">{{ objPedido.tipolente.Nombre }}</p>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Articulo</b>
                            </label>
                            <p v-if="objPedido.articulo !== null">{{ objPedido.articulo.Nombre }}</p>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b>  Material</b>
                            </label>
                            <p v-if="objPedido.material !== null">{{ objPedido.material.Nombre }}</p>
                        </div>
                        <hr style="background-color: grey;">
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Proteccion</b>
                            </label>
                            <p v-if="objPedido.proteccion !== null">{{ objPedido.proteccion.Nombre }}</p>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Recubrimiento</b>
                            </label>
                            <p v-if="objPedido.recubrimiento !== null">{{ objPedido.recubrimiento.Nombre }}</p>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b>  Armazon</b>
                            </label>
                            <p v-if="objPedido.armazon !== null" style="text-transform: uppercase;">{{ objPedido.armazon.Nombre }}</p>
                        </div>
                        <hr style="background-color: grey;">
                    </div>

                    <div class="row">
                        <h6>Tabla RX</h6>
                        <div class="col-12 col-md-12 col-xl-12">
                            <div class="">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>OJO</th>
                                            <th>Esfera</th>
                                            <th>Cilindro</th>
                                            <th>Eje</th>
                                            <th>Adicion</th>
                                            <th>Alt. Mont.</th>
                                            <th>Dnp.</th>
                                            <th>Prisma</th>
                                            <th>Posición</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="objPedido.OjoDerecho">
                                            <td>OD</td>
                                            <td class="text-center">
                                                <template v-if="parseFloat(objPedido.OdEsfera) > 0"> + {{ objPedido.OdEsfera }}</template>
                                                <template v-else-if="parseFloat(objPedido.OdEsfera) < 0">{{ objPedido.OdEsfera }}</template>
                                                <template v-else>0.00</template>
                                            </td>
                                            <td class="text-center">
                                                <template v-if="parseFloat(objPedido.OdCilindro) > 0"> + {{ objPedido.OdCilindro }}</template>
                                                <template v-else-if="parseFloat(objPedido.OdCilindro) < 0"> {{ objPedido.OdCilindro }}</template>
                                                <template v-else>0.00</template>
                                            </td>
                                            <td class="text-center">
                                                <template v-if="parseInt(objPedido.OdEje) > 0">{{ objPedido.OdEje }}°</template>
                                                <template v-else>0°</template>
                                            </td>
                                            <td class="text-center">
                                                <template v-if="parseFloat(objPedido.OdAdicion) > 0"> + {{ objPedido.OdAdicion }}</template>
                                                <template v-else-if="parseFloat(objPedido.OdAdicion) < 0"> {{ objPedido.OdAdicion }}</template>
                                                <template v-else></template>
                                            </td>
                                            <td class="text-center">
                                                <template v-if="objPedido.OdAltMon != null && objPedido.OdAltMon != '' "> {{ objPedido.OdAltMon }} mm</template>
                                                <!-- <template v-else>0 mm</template> -->
                                            </td>
                                            <td class="text-center"> <template v-if="objPedido.OdDnp != null && objPedido.OdDnp != '' "> {{ objPedido.OdDnp }} mm</template> </td>
                                            <td class="text-center"> <template v-if="objPedido.OdPrisma != null && objPedido.OdPrisma != '' "> {{ objPedido.OdPrisma }}mm</template> </td>
                                            <td class="text-center">{{ objPedido.OdPosicion }}</td>
                                            
                                        </tr>

                                        <tr v-if="objPedido.OjoIzquierdo">
                                            <td>OI</td>
                                            <td class="text-center">
                                                <template v-if="parseFloat(objPedido.OiEsfera) > 0"> + {{ objPedido.OiEsfera }}</template>
                                                <template v-else-if="parseFloat(objPedido.OiEsfera) < 0">{{ objPedido.OiEsfera }}</template>
                                                <template v-else>0.00</template>
                                            </td>
                                            <td class="text-center">
                                                <template v-if="parseFloat(objPedido.OiCilindro) > 0"> + {{ objPedido.OiCilindro }}</template>
                                                <template v-else-if="parseFloat(objPedido.OiCilindro) < 0"> {{ objPedido.OiCilindro }}</template>
                                                <template v-else>0.00</template>
                                            </td>
                                            <td class="text-center">
                                                <template v-if="parseInt(objPedido.OiEje) > 0">{{ objPedido.OiEje }}°</template>
                                                <template v-else>0°</template>
                                            </td>
                                            <td class="text-center">
                                                <template v-if="parseFloat(objPedido.OiAdicion) > 0"> + {{ objPedido.OiAdicion }}</template>
                                                <template v-else-if="parseFloat(objPedido.OiAdicion) < 0"> {{ objPedido.OiAdicion }}</template>
                                                <template v-else></template>
                                            </td>
                                            <td class="text-center"> <template v-if="objPedido.OiAltMon != null && objPedido.OiAltMon != '' "> {{ objPedido.OiAltMon }} mm</template>   </td>
                                            <td class="text-center"> <template v-if="objPedido.OiDnp != null && objPedido.OiDnp != '' "> {{ objPedido.OiDnp }} mm</template>            </td>
                                            <td class="text-center"> <template v-if="objPedido.OiPrisma != null && objPedido.OiPrisma != '' "> {{ objPedido.OiPrisma }} mm</template>   </td>
                                            <td class="text-center"> {{ objPedido.OiPosicion }}</td>
                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <hr style="background-color: grey;">
                    </div>

                    <div class="row" v-if="objPedido.articulo.AnguloPantoscopico == 'SI' || objPedido.articulo.AnguloPanoramico == 'SI' || objPedido.articulo.DistanciaLectura == 'SI' || objPedido.articulo.DistanciaVertice == 'SI' || objPedido.articulo.Iniciales == 'SI' || objPedido.articulo.ReqAltSeg">
                        <h6>Parametros de Personalización</h6>
                        <div class="col-12 col-md-12 col-xl-12">
                            <div class="">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th v-if="objPedido.articulo.ReqAltSeg          == 'SI'">Alt. Segmento</th>
                                            <th v-if="objPedido.articulo.AnguloPantoscopico == 'SI'">Ang. Pantoscópico</th>
                                            <th v-if="objPedido.articulo.AnguloPanoramico   == 'SI'">Ang. Panorómico</th>
                                            <th v-if="objPedido.articulo.DistanciaVertice   == 'SI'">Dist. al vertice</th>
                                            <th v-if="objPedido.articulo.DistanciaLectura   == 'SI'">Dist. de lectura</th>
                                          
                                            <th v-if="objPedido.articulo.Iniciales          == 'SI'">Iniciales</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td v-if="objPedido.articulo.ReqAltSeg          == 'SI'">{{ objPedido.AlturaSegmento }}</td>
                                            <td v-if="objPedido.articulo.AnguloPantoscopico == 'SI'">{{ objPedido.AnguloPantoscopico }}</td>
                                            <td v-if="objPedido.articulo.AnguloPanoramico   == 'SI'">{{ objPedido.AnguloPanoramico }}</td>
                                            <td v-if="objPedido.articulo.DistanciaVertice   == 'SI'">{{ objPedido.DistanciaVertice }}</td>
                                            <td v-if="objPedido.articulo.DistanciaLectura   == 'SI'">{{ objPedido.DistanciaLectura }}</td>
                                            
                                            <td v-if="objPedido.articulo.Iniciales          == 'SI'">{{ objPedido.Iniciales }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <hr style="background-color: grey;">
                    </div>

                    <div v-if="objPedido.EnviaArmazon" class="row">
                        <div class="col-12 col-md-3 col-xl-3">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Envia Armazon</b>
                            </label>
                            <p v-if="objPedido.EnviaArmazon"> SI</p>
                            <p v-else> NO</p>
                        </div>
                        <div class="col-12 col-md-3 col-xl-3">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Estado del Armazon</b>
                            </label>
                            <p style="text-transform: uppercase;">{{ objPedido.EstadoArmazon }}</p>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b>  Bisel</b>
                            </label>
                            <p v-if="objPedido.bisel != null" style="text-transform: uppercase;">{{ objPedido.bisel.Nombre }}</p>
                        </div>

                        <div v-if="objPedido.UsaBiselSencillo" class="col-12 col-md-2 col-xl-2">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Pulido</b>
                            </label>
                            <p>SI</p>
                        </div>
                        <hr style="background-color: grey;">
                    </div>

                    <div v-if="objPedido.EnviaArmazon" class="row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Marca</b>
                            </label>
                            <p style="text-transform: uppercase;">{{ objPedido.MarcaArmazon }}</p>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Modelo</b>
                            </label>
                            <p style="text-transform: uppercase;">{{ objPedido.ModeloArmazon }}</p>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Color</b>
                            </label>
                            <p style="text-transform: uppercase;">{{ objPedido.ColorArmazon }}</p>
                        </div>
                        <hr style="background-color: grey;">
                    </div>

                    <!-- CAMBIO DE FORMA -->
                    <div v-if="objPedido.CambioForma" class="row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Cambio de Forma</b>
                            </label>
                            <p v-if="objPedido.CambioForma"> SI</p>
                            <p v-else> NO</p>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Escanear Forma</b>
                            </label>
                            <p style="text-transform: uppercase;">{{ objPedido.EscanearForma }}</p>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Montar en Armazón</b>
                            </label>
                            <p style="text-transform: uppercase;">{{ objPedido.MontarArmazon }}</p>
                        </div>
                        
                        
                        <hr style="background-color: grey;">
                    </div>

                    <!-- AUMENTO DE MEDIDAS Y CONTORNO -->
                    <div v-if="objPedido.AumentarMedida == 'AumentarMedida' || objPedido.AumentarMedida == 'AumentarContorno'" class="row">

                        <div class="col-12 col-md-3 col-xl-3">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Tipo de Cambio</b>
                            </label>
                            <p style="text-transform: uppercase;" v-if="objPedido.AumentarMedida == 'AumentarMedida'"> Aumento de Medidas</p>
                            <p style="text-transform: uppercase;" v-if="objPedido.AumentarMedida == 'AumentarContorno'"> Aumento de Contorno</p>
                        </div>

                        <div v-if="objPedido.AumentarMedida == 'AumentarMedida'" class="col-12 col-md-3 col-xl-3">
                            <label> 
                                <i class="fa fa-check-circle"></i> 
                                <b> Arriba</b> 
                            </label>
                            <p> <i class="fas fa-arrow-to-top"></i> {{ objPedido.AumentarArriba }} mm</p>
                        </div>

                        <div v-if="objPedido.AumentarMedida == 'AumentarMedida'" class="col-12 col-md-3 col-xl-3">
                            <label> <i class="fa fa-check-circle"></i>  Abajo</label>
                            <p> <i class="fas fa-arrow-to-bottom"></i> {{ objPedido.AumentaAbajo }} mm</p>
                        </div>

                        <div v-if="objPedido.AumentarMedida == 'AumentarMedida'" class="col-12 col-md-3 col-xl-3">
                            <label> <i class="fa fa-check-circle"></i> Temporal</label>
                            <p> <i class="fas fa-arrow-to-right"></i> {{ objPedido.AumentaDerecho }} mm</p>
                        </div>

                        <div v-if="objPedido.AumentarMedida == 'AumentarContorno'" class="col-12 col-md-3 col-xl-3">
                            <label> <i class="fa fa-check-circle"></i> Contorno</label>
                            <p> <i class="fal fa-circle"></i> {{ objPedido.Contorno }} mm</p>
                        </div>

                        <hr style="background-color: grey;">
                    </div>
                    
                    <!-- ENTINTADOS -->
                    <div v-if="objPedido.ReqTinte" class="row">
                        <div class="col-12 col-md-3 col-xl-3">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Requiere Entintar</b>
                            </label>
                            <p v-if="objPedido.ReqTinte"> SI</p>
                            <p v-else> NO</p>
                        </div>
                        <div class="col-12 col-md-3 col-xl-3">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Color</b>
                            </label>
                            <p v-if="objPedido.ReqTinte && objPedido.color != null">
                                <i v-if="objPedido.color.Nombre != ''" :title="objPedido.color.Nombre" v-b-tooltip.hover class="fas fa-circle fa-lg" :style="'color:'+objPedido.color.Color+';'"></i> {{ objPedido.color.Nombre }}
                            </p>
                        </div>
                        <div class="col-12 col-md-3 col-xl-3">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Tono</b>
                            </label>
                            <p v-if="objPedido.ReqTinte">
                                <template v-if="parseInt(objPedido.Tono) == 1"><i title="Tono 1" v-b-tooltip.hover class="fas fa-circle fa-lg" style="color:#c3c4c5;"></i> Tono 1</template>
                                <template v-if="parseInt(objPedido.Tono) == 2"><i title="Tono 2" v-b-tooltip.hover class="fas fa-circle fa-lg" style="color:#9e9fa0;"></i> Tono 2</template>
                                <template v-if="parseInt(objPedido.Tono) == 3"><i title="Tono 3" v-b-tooltip.hover class="fas fa-circle fa-lg" style="color:#6a6a6b;"></i> Tono 3</template>
                            </p>
                        </div>
                        <div class="col-12 col-md-3 col-xl-3">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Coloración</b>
                            </label>
                            <p v-if="objPedido.ReqTinte">
                                <template v-if="parseInt(objPedido.Coloracion) == 1"><i title="Uniforme" v-b-tooltip.hover class="fas fa-circle fa-lg" style="color:#c3c4c5;"></i> Uniforme</template>
                                <template v-if="parseInt(objPedido.Coloracion) == 2"> <i class="dot"></i> Desvanecido</template>
                            </p>
                        </div>
                        <hr style="background-color: grey;">
                    </div>
                    
                    <div class="row">
                        <div class="col-12 col-lg-4 col-xl-3">
                            <img src="@/assets/style/image/duarte-02.png" alt="Logo" style="width: 95%;" class="">
                        </div>

                        <!-- <div v-if="objPedido.EnviaArmazon == true" class="col-12 col-lg-4 col-xl-2"> -->
                        <div class="col-12 col-lg-4 col-xl-2">
                            <div class="row">
                                <div class="col-12">
                                    <p><b>DBL:</b>  {{ objPedido.DBL }}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <p><b>ED:</b>  {{ objPedido.ED }}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <p><b>B:</b>  {{ objPedido.B }}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <p><b>A:</b>  {{ objPedido.A }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-4 col-xl-7">

                            <div class="row">
                                <div class="col-12">
                                    <label><i class="fa fa-check-circle"></i> Observaciones Generales</label>
                                    <p>{{ objPedido.ObservacionesGeneral }}</p>
                                </div>
                            </div>

                        </div>

                        <hr class="mt-3" style="background-color: grey;">
                    </div>
                    
                </template>

                <template v-if="parseInt(objPedido.tipolente.Proceso) == 2">
                    <template v-if="parseInt(objPedido.NumPar) == 1">
                        <div class="row">
                            <div class="col-12 col-md-4 col-xl-4">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Tipo de lente</b>
                                </label>
                                <p v-if="objPedido.tipolente !== null" style="text-transform: uppercase;">{{ objPedido.tipolente.Nombre }}</p>
                            </div>
                            <div class="col-12 col-md-4 col-xl-4">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Articulo</b>
                                </label>
                                <p v-if="objPedido.articulo !== null">{{ objPedido.articulo.Nombre }}</p>
                            </div>
                            <div class="col-12 col-md-4 col-xl-4">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b>  Armazon</b>
                                </label>
                                <p v-if="objPedido.armazon !== null" style="text-transform: uppercase;">{{ objPedido.armazon.Nombre }}</p>
                            </div>
                            <hr style="background-color: grey;">
                        </div>

                        <div class="row">
                            <h6>Tabla RX</h6>
                            <div class="col-12 col-md-12 col-xl-12">
                                <div class="">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>OJO</th>
                                                <th>Esfera</th>
                                                <th>Cilindro</th>
                                                <th>Eje</th>
                                                <th>Adicion</th>
                                                <th>Alt. Mont.</th>
                                                <th>Alt. Seg.</th>
                                                <th>Dnp.</th>
                                                <th>Prisma</th>
                                                <th>Posición</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="objPedido.OjoDerecho">
                                                <td>OD</td>
                                                <td class="text-center">
                                                    <template v-if="parseFloat(objPedido.OdEsfera) > 0"> + {{ objPedido.OdEsfera }}</template>
                                                    <template v-else-if="parseFloat(objPedido.OdEsfera) < 0">{{ objPedido.OdEsfera }}</template>
                                                    <template v-else>0.00</template>
                                                </td>
                                                <td class="text-center">
                                                    <template v-if="parseFloat(objPedido.OdCilindro) > 0"> + {{ objPedido.OdCilindro }}</template>
                                                    <template v-else-if="parseFloat(objPedido.OdCilindro) < 0"> {{ objPedido.OdCilindro }}</template>
                                                    <template v-else>0.00</template>
                                                </td>
                                                <td class="text-center">
                                                    <template v-if="parseInt(objPedido.OdEje) > 0">{{ objPedido.OdEje }}°</template>
                                                    <template v-else>0°</template>
                                                </td>
                                                <td class="text-center">
                                                    <template v-if="parseFloat(objPedido.OdAdicion) > 0"> + {{ objPedido.OdAdicion }}</template>
                                                    <template v-else-if="parseFloat(objPedido.OdAdicion) < 0"> {{ objPedido.OdAdicion }}</template>
                                                    <template v-else></template>
                                                </td>
                                                <td class="text-center"> <template v-if="objPedido.OdAltMon != null && objPedido.OdAltMon != '' "> {{ objPedido.OdAltMon }} mm</template> </td>
                                                <td class="text-center"> <template v-if="objPedido.OdAltSeg != null && objPedido.OdAltSeg != '' "> {{ objPedido.OdAltSeg }} mm</template> </td>
                                                <td class="text-center"> <template v-if="objPedido.OdDnp != null && objPedido.OdDnp != '' "> {{ objPedido.OdDnp }} mm</template> </td>
                                                <td class="text-center"> <template v-if="objPedido.OdPrisma != null && objPedido.OdPrisma != '' "> {{ objPedido.OdPrisma }}mm</template> </td>
                                                <td class="text-center">{{ objPedido.OdPosicion }}</td>
                                                
                                            </tr>

                                            <tr v-if="objPedido.OjoIzquierdo">
                                                <td>OI</td>
                                                <td class="text-center">
                                                    <template v-if="parseFloat(objPedido.OiEsfera) > 0"> + {{ objPedido.OiEsfera }}</template>
                                                    <template v-else-if="parseFloat(objPedido.OiEsfera) < 0">{{ objPedido.OiEsfera }}</template>
                                                    <template v-else>0.00</template>
                                                </td>
                                                <td class="text-center">
                                                    <template v-if="parseFloat(objPedido.OiCilindro) > 0"> + {{ objPedido.OiCilindro }}</template>
                                                    <template v-else-if="parseFloat(objPedido.OiCilindro) < 0"> {{ objPedido.OiCilindro }}</template>
                                                    <template v-else>0.00</template>
                                                </td>
                                                <td class="text-center">
                                                    <template v-if="parseInt(objPedido.OiEje) > 0">{{ objPedido.OiEje }}°</template>
                                                    <template v-else>0°</template>
                                                </td>
                                                <td class="text-center">
                                                    <template v-if="parseFloat(objPedido.OiAdicion) > 0"> + {{ objPedido.OiAdicion }}</template>
                                                    <template v-else-if="parseFloat(objPedido.OiAdicion) < 0"> {{ objPedido.OiAdicion }}</template>
                                                    <template v-else></template>
                                                </td>
                                                <td class="text-center"> <template v-if="objPedido.OiAltMon != null && objPedido.OiAltMon != '' "> {{ objPedido.OiAltMon }} mm</template>   </td>
                                                <td class="text-center"> <template v-if="objPedido.OiAltSeg != null && objPedido.OiAltSeg != '' "> {{ objPedido.OiAltSeg }} mm</template>   </td>
                                                <td class="text-center"> <template v-if="objPedido.OiDnp != null && objPedido.OiDnp != '' "> {{ objPedido.OiDnp }} mm</template>            </td>
                                                <td class="text-center"> <template v-if="objPedido.OiPrisma != null && objPedido.OiPrisma != '' "> {{ objPedido.OiPrisma }} mm</template>   </td>
                                                <td class="text-center"> {{ objPedido.OiPosicion }}</td>
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <hr style="background-color: grey;">
                        </div>

                        <div v-if="objPedido.EnviaArmazon" class="row">
                            <div class="col-12 col-md-3 col-xl-3">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Envia Armazon</b>
                                </label>
                                <p v-if="objPedido.EnviaArmazon"> SI</p>
                                <p v-else> NO</p>
                            </div>
                            <div class="col-12 col-md-3 col-xl-3">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Estado del Armazon</b>
                                </label>
                                <p style="text-transform: uppercase;">{{ objPedido.EstadoArmazon }}</p>
                            </div>
                            <div class="col-12 col-md-4 col-xl-4">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b>  Bisel</b>
                                </label>
                                <p v-if="objPedido.bisel != null" style="text-transform: uppercase;">{{ objPedido.bisel.Nombre }}</p>
                            </div>

                            <div v-if="objPedido.UsaBiselSencillo" class="col-12 col-md-2 col-xl-2">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Pulido</b>
                                </label>
                                <p>SI</p>
                            </div>
                            <hr style="background-color: grey;">
                        </div>

                        <div v-if="objPedido.EnviaArmazon" class="row">
                            <div class="col-12 col-md-4 col-xl-4">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Marca</b>
                                </label>
                                <p style="text-transform: uppercase;">{{ objPedido.MarcaArmazon }}</p>
                            </div>
                            <div class="col-12 col-md-4 col-xl-4">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Modelo</b>
                                </label>
                                <p style="text-transform: uppercase;">{{ objPedido.ModeloArmazon }}</p>
                            </div>
                            <div class="col-12 col-md-4 col-xl-4">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Color</b>
                                </label>
                                <p style="text-transform: uppercase;">{{ objPedido.ColorArmazon }}</p>
                            </div>
                            <hr style="background-color: grey;">
                        </div>

                        <!-- CAMBIO DE FORMA -->
                        <div v-if="objPedido.CambioForma" class="row">
                            <div class="col-12 col-md-4 col-xl-4">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Cambio de Forma</b>
                                </label>
                                <p v-if="objPedido.CambioForma"> SI</p>
                                <p v-else> NO</p>
                            </div>
                            <div class="col-12 col-md-4 col-xl-4">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Escanear Forma</b>
                                </label>
                                <p style="text-transform: uppercase;">{{ objPedido.EscanearForma }}</p>
                            </div>
                            <div class="col-12 col-md-4 col-xl-4">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Montar en Armazón</b>
                                </label>
                                <p style="text-transform: uppercase;">{{ objPedido.MontarArmazon }}</p>
                            </div>
                            
                            
                            <hr style="background-color: grey;">
                        </div>

                        <!-- AUMENTO DE MEDIDAS Y CONTORNO -->
                        <div v-if="objPedido.AumentarMedida == 'AumentarMedida' || objPedido.AumentarMedida == 'AumentarContorno'" class="row">

                            <div class="col-12 col-md-3 col-xl-3">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Tipo de Cambio</b>
                                </label>
                                <p style="text-transform: uppercase;" v-if="objPedido.AumentarMedida == 'AumentarMedida'"> Aumento de Medidas</p>
                                <p style="text-transform: uppercase;" v-if="objPedido.AumentarMedida == 'AumentarContorno'"> Aumento de Contorno</p>
                            </div>

                            <div v-if="objPedido.AumentarMedida == 'AumentarMedida'" class="col-12 col-md-3 col-xl-3">
                                <label> 
                                    <i class="fa fa-check-circle"></i> 
                                    <b> Arriba</b> 
                                </label>
                                <p> <i class="fas fa-arrow-to-top"></i> {{ objPedido.AumentarArriba }} mm</p>
                            </div>

                            <div v-if="objPedido.AumentarMedida == 'AumentarMedida'" class="col-12 col-md-3 col-xl-3">
                                <label> <i class="fa fa-check-circle"></i>  Abajo</label>
                                <p> <i class="fas fa-arrow-to-bottom"></i> {{ objPedido.AumentaAbajo }} mm</p>
                            </div>

                            <div v-if="objPedido.AumentarMedida == 'AumentarMedida'" class="col-12 col-md-3 col-xl-3">
                                <label> <i class="fa fa-check-circle"></i> Temporal</label>
                                <p> <i class="fas fa-arrow-to-right"></i> {{ objPedido.AumentaDerecho }} mm</p>
                            </div>

                            <div v-if="objPedido.AumentarMedida == 'AumentarContorno'" class="col-12 col-md-3 col-xl-3">
                                <label> <i class="fa fa-check-circle"></i> Contorno</label>
                                <p> <i class="fal fa-circle"></i> {{ objPedido.Contorno }} mm</p>
                            </div>

                            <hr style="background-color: grey;">
                        </div>
                        
                        <!-- ENTINTADOS -->
                        <div v-if="objPedido.ReqTinte" class="row">
                            <div class="col-12 col-md-3 col-xl-3">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Requiere Entintar</b>
                                </label>
                                <p v-if="objPedido.ReqTinte"> SI</p>
                                <p v-else> NO</p>
                            </div>
                            <div class="col-12 col-md-3 col-xl-3">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Color</b>
                                </label>
                                <p v-if="objPedido.ReqTinte && objPedido.color != null">
                                    <i v-if="objPedido.color.Nombre != ''" :title="objPedido.color.Nombre" v-b-tooltip.hover class="fas fa-circle fa-lg" :style="'color:'+objPedido.color.Color+';'"></i> {{ objPedido.color.Nombre }}
                                </p>
                            </div>
                            <div class="col-12 col-md-3 col-xl-3">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Tono</b>
                                </label>
                                <p v-if="objPedido.ReqTinte">
                                    <template v-if="parseInt(objPedido.Tono) == 1"><i title="Tono 1" v-b-tooltip.hover class="fas fa-circle fa-lg" style="color:#c3c4c5;"></i> Tono 1</template>
                                    <template v-if="parseInt(objPedido.Tono) == 2"><i title="Tono 2" v-b-tooltip.hover class="fas fa-circle fa-lg" style="color:#9e9fa0;"></i> Tono 2</template>
                                    <template v-if="parseInt(objPedido.Tono) == 3"><i title="Tono 3" v-b-tooltip.hover class="fas fa-circle fa-lg" style="color:#6a6a6b;"></i> Tono 3</template>
                                </p>
                            </div>
                            <div class="col-12 col-md-3 col-xl-3">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Coloración</b>
                                </label>
                                <p v-if="objPedido.ReqTinte">
                                    <template v-if="parseInt(objPedido.Coloracion) == 1"><i title="Uniforme" v-b-tooltip.hover class="fas fa-circle fa-lg" style="color:#c3c4c5;"></i> Uniforme</template>
                                    <template v-if="parseInt(objPedido.Coloracion) == 2"> <i class="dot"></i> Desvanecido</template>
                                </p>
                            </div>
                            <hr style="background-color: grey;">
                        </div>

                        <div class="row">
                            <div v-if="objPedido.DBL != '' && objPedido.DBL != null" class="col-12 col-lg-4 col-xl-3">
                                <img src="@/assets/style/image/duarte-02.png" alt="Logo" style="width: 95%;" class="">
                            </div>

                            
                            <div v-if="objPedido.DBL != '' && objPedido.DBL != null" class="col-12 col-lg-4 col-xl-2">
                                <div class="row">
                                    <div class="col-12">
                                        <p><b>DBL:</b>  {{ objPedido.DBL }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <p><b>ED:</b>  {{ objPedido.ED }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <p><b>B:</b>  {{ objPedido.B }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <p><b>A:</b>  {{ objPedido.A }}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-lg-4 col-xl-7">

                                <div class="row">
                                    <div class="col-12">
                                        <label><i class="fa fa-check-circle"></i> Observaciones Generales</label>
                                        <p>{{ objPedido.ObservacionesGeneral }}</p>
                                    </div>
                                </div>

                            </div>

                            <hr class="mt-3" style="background-color: grey;">
                        </div>
                    </template>

                    <template v-else-if="parseInt(objPedido.NumPar) == 2">
                        <div class="row">
                            <div class="col-12 col-md-4 col-xl-4">
                                <label>
                                    <i class="fa fa-check-circle"></i>
                                    <b> Tipo de lente</b>
                                </label>
                                <p v-if="objPedido.tipolente !== null" style="text-transform: uppercase;">{{ objPedido.tipolente.Nombre }}</p>
                            </div>
                            <hr style="background-color: grey;">
                        </div>

                        <div class="row mt-1">
                            <h6>Detalle de Articulos</h6>
                            <div class="col-12 col-md-12 col-xl-12">
                                
                                    <table class="table">
                                        <thead>
                                            <th>Articulo</th>
                                            <th class="text-center">Esfera</th>
                                            <th class="text-center">Cilindro</th>
                                            <th class="text-center">Cantidad</th>
                                            
                                        </thead>
                                        <tbody>
                                            <tr v-for="(itemtbl,indxtbl) in objPedido.detallepedidolt"  :key="indxtbl">
                                                <td>{{ itemtbl.Nombre }}</td>
                                                <td class="text-center">{{ itemtbl.Esfera }}</td>
                                                <td class="text-center">{{ itemtbl.Cilindro }}</td>
                                                <td class="text-center">{{ itemtbl.Cantidad }}</td>
                                               
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                                
                            </div>
                            <hr class="mt-3" style="background-color: grey;">
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <label><i class="fa fa-check-circle"></i> Observaciones Generales</label>
                                <p>{{ objPedido.ObservacionesGeneral }}</p>
                            </div>
                        </div>
                        <hr class="mt-3" style="background-color: grey;">
                    </template>

                </template>
                
                <template v-if="parseInt(objPedido.tipolente.Proceso) == 3">
                    <div class="row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <label>
                                <i class="fa fa-check-circle"></i>
                                <b> Tipo de lente</b>
                            </label>
                            <p v-if="objPedido.tipolente !== null" style="text-transform: uppercase;">{{ objPedido.tipolente.Nombre }}</p>
                        </div>
                        <hr style="background-color: grey;">
                    </div>

                    <div class="row mt-2">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div>
                                <table class="table">
                                    <thead>
                                        <th>Articulo</th>
                                        <th class="text-center">Esfera</th>
                                        <th class="text-center">Cilindro</th>
                                        <th class="text-center">Eje</th>
                                        <th class="text-center">Adicion</th>
                                        <th class="text-center">Color</th>
                                        <th class="text-center">Cantidad</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(itemtbl,indxtbl) in objPedido.detallepedidolc"  :key="indxtbl">
                                            <td>{{ itemtbl.Nombre }}</td>
                                            <td class="text-center">{{ itemtbl.Esfera }}</td>
                                            <td class="text-center">{{ itemtbl.Cilindro }}</td>
                                            <td class="text-center">{{ itemtbl.Eje }}<span v-if="itemtbl.Eje != ''">°</span></td>
                                            <td class="text-center"><i v-if="parseFloat(itemtbl.Adicion) >= 0" class="fas fa-plus fa-xs"></i> <b>{{ itemtbl.Adicion }}</b> </td>
                                            <td class="text-center"><i v-if="itemtbl.NombreColor != '' && itemtbl.NombreColor != null" :title="itemtbl.NombreColor" v-b-tooltip.hover class="fas fa-circle fa-lg" :style="'color:'+itemtbl.Color+';'"></i> {{ itemtbl.NombreColor }}</td>
                                            <td class="text-center">{{ itemtbl.Cantidad }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <hr class="mt-3" style="background-color: grey;">
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <label><i class="fa fa-check-circle"></i> Observaciones Generales</label>
                            <p>{{ objPedido.ObservacionesGeneral }}</p>
                        </div>
                        <hr class="mt-3" style="background-color: grey;">
                    </div>

                </template>

                <!-- DETALLE DEL PEDIDO -->
                <div class="row">
                    <h6>Resumen de Costos</h6>
                    <div class="col-12 col-md-12 col-xl-12">
                        <div class="">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Articulo</th>
                                        <th>Clave</th>
                                        <!--<th class="text-center">Tipo</th> -->
                                        <th class="text-end">Precio</th>
                                        <th class="text-end">Cantidad</th>
                                        <th class="text-end">Descuento</th>
                                        <th class="text-end">Importe</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in detallePedido" :key="index">
                                        <td style="vertical-align: middle !important;"><b>{{ item.Descripcion }}</b></td>
                                        <td style="vertical-align: middle !important;">{{ item.Clave }}</td>
                                        <!--<td class="text-center" style="vertical-align: middle !important;">
                                            <span v-if="item.TipoDet == 'Proteccion'">Articulo</span>
                                            <span v-else>{{ item.TipoDet }}</span>
                                        </td> -->
                                        <td class="text-end" style="vertical-align: middle !important;">{{ $formatNumber(item.Precio,'$') }}</td>
                                        <td class="text-end" style="vertical-align: middle !important;">{{ item.Cantidad }}</td>
                                        <td class="text-end" style="vertical-align: middle !important;">{{ $formatNumber(item.PrecioDesc,'$') }}</td>
                                        <td class="text-end" style="vertical-align: middle !important;">{{ $formatNumber(item.Importe,'$') }}</td>
                                    </tr>
                                </tbody>
                                <tfoot class="text-end">
                                    <tr>
                                        <td colspan="4"></td>
                                        <td><h6>Subtotal</h6></td>
                                        <td>{{ $formatNumber(objPedido.SubTotal,'$') }}</td>
                                    </tr>

                                    <tr>
                                        <td colspan="4"></td>
                                        <td><h6>Descuentos</h6></td>
                                        <td>{{ $formatNumber(objPedido.Descuento,'$') }}</td>
                                    </tr>

                                    <tr>
                                        <td colspan="4"></td>
                                        <td><h6>IVA</h6></td>
                                        <td>{{ $formatNumber(objPedido.Iva,'$') }}</td>
                                    </tr>
                                    
                                    <tr>
                                        <td colspan="4"></td>
                                        <td><h5>Total</h5></td>
                                        <td><h5>{{ $formatNumber(objPedido.GranTotal,'$') }}</h5></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </template>
    </CLoader>
</template>
<script>
import Template from '../../template/Template.vue';
export default {
    name: 'ResumenPedido',
    props: ['pOrigen','pObjetoPedido','poBtnSave'],
    components:{Template},
    data() {
        return {
            Emit: this.poBtnSave.EmitSeccion,
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },

            objPedido: {
				IdPedido: 0,
				IdCliente: 0,
				IdUsuario: 0,
				IdSubLinea: 0,
				IdArticuloWeb: 0,
				IdMaterial: 0,
				IdProteccion: 0,
				IdRecubrimiento: 0,
				IdArmazon: 0,
				IdBisel: 0,
				IdTipoLente: 0,
				Estatus: '',
				FolioCotizacion: '',
				FolioPedido: '',
				Fecha: '',
				Paciente: '',

				OjoDerecho: true,
				OdEsfera: '',
				OdCilindro: '',
				OdEje: '',
				OdAdicion: '',
				OdPrisma: '',
				OdDnp: '',
				OdAltMon: '',
				OdAltSeg: '',
				OdPosicion: '',

				OjoIzquierdo: true,
				OiEsfera: '',
				OiCilindro: '',
				OiEje: '',
				OiAdicion: '',
				OiPrisma: '',
				OiDnp: '',
				OiAltMon: '',
				OiAltSeg: '',
				OiPosicion: '',

				ReqTinte: '',
				IdColor: 0,
				Color: '',
				Tono: '',
				Coloracion: '',
				NumPar: 0,
			
				UsaBiselSencillo: false,
				IdBiselSencillo: 0,
				IdSubBisel: 0,
				NumGrapas: 0,

				Perforacion: '',
				
				ObservacionesGeneral: '',
				SubLinea: '',
				Articulo: '',
				Material: '',
				Proteccion: '',
				Recubrimiento: '',
				Armazon: '',
				AnguloPantoscopico: '',
				AnguloPanoramico: '',
				DistanciaVertice: '',
				DistanciaLectura: '',
				Iniciales: '',

				// PASO 3
				EnviaArmazon: false,
				MarcaArmazon: '',
				ColorArmazon: '',
				ModeloArmazon: '',
				EstadoArmazon: '',

				CambioForma: '',
				EscanearForma: '',
				MontarArmazon: '',
				AumentarArriba: '',
				AumentaAbajo: '',
				AumentaDerecho: '',
				Contorno: '',
				DBL: '',
				ED: '',
				B: '',
				A: '',
				AumentarMedida: 'NO',
				
				SubTotal: 0,
				Iva: 0,
				GranTotal: 0,
				FolioEnviado: '',
				Insertado: '',

                cliente: { Nombre: ''},
                tipolente: {Nombre: '', Proceso:0},
                sublinea: {Nombre: ''},
                articulo: {Nombre: ''},
                material: {Nombre: ''},
                proteccion: {Nombre: ''},
                recubrimiento: {Nombre: ''},
                armazon: {Nombre: ''},
                bisel: {Nombre: ''},
                color: {Nombre: ''},
            },

            detallePedido: [],
            detallepedidolt: [],
            detallepedidolc: [],
        }
    },
    methods:{
        Recuperar()
        {   
            this.ConfigLoad.ShowLoader = true;
            this.$http.get("pedidosresumen/"+this.objPedido.IdPedido)
            .then((res) => {
                this.objPedido = res.data.data;
				this.objCliente  = this.objPedido.cliente;
				this.detallePedido = this.objPedido.detalle;
				this.detallepedidolt = this.objPedido.detallepedidolt;
				this.detallepedidolc = this.objPedido.detallepedidolc;

				this.objPedido.EnviaArmazon     = (parseInt(this.objPedido.EnviaArmazon) == 1) ? true : false;
				this.objPedido.ReqTinte         = (parseInt(this.objPedido.ReqTinte) == 1) ? true : false;
				this.objPedido.CambioForma      = (parseInt(this.objPedido.CambioForma) == 1) ? true : false;
				this.objPedido.UsaBiselSencillo = (parseInt(this.objPedido.UsaBiselSencillo) == 1) ? true : false;
				this.objPedido.OjoDerecho       = (parseInt(this.objPedido.OjoDerecho) == 1) ? true : false;
				this.objPedido.OjoIzquierdo     = (parseInt(this.objPedido.OjoIzquierdo) == 1) ? true : false;
				
				
				
				
				// en caso de que necesite fecha
				/*let formatedDate1 = this.objPedido.Fecha.replace(/-/g,'\/');
                this.objPedido.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },

        setPedido() {
            this.objCliente         = this.objPedido.cliente;
            this.detallePedido      = this.objPedido.detallePedido;
            let detMLT    = this.objPedido.detallepedidolt.map( item => ({
                    Cantidad: item.Cantidad,
                    Nombre: item.Descripcion,
                    IdArticuloWeb: item.IdArticuloWeb,
                    Cilindro: item.ValCilindro,
                    Esfera: item.ValEsfera,
                })
            );
            this.objPedido.detallepedidolt = detMLT;

            let detLC     =  this.objPedido.detallepedidolc.map( item => ({
                    Nombre: item.Descripcion,
                    IdArticuloWeb: item.IdArticuloWeb,
                    Cantidad: item.Cantidad,
                    Cilindro: item.Cilindro,
                    Esfera: item.Esfera,
                    Eje: item.Eje,
                    Adicion: item.Adicion,
                    NombreColor: item.NombreColor,
                    Color: item.Color
                })
            );
            this.objPedido.detallepedidolc    = detLC;


            /*this.objPedido.EnviaArmazon     = (parseInt(this.objPedido.EnviaArmazon) == 1) ? true : false;
            this.objPedido.ReqTinte         = (parseInt(this.objPedido.ReqTinte) == 1) ? true : false;
            this.objPedido.CambioForma      = (parseInt(this.objPedido.CambioForma) == 1) ? true : false;
            this.objPedido.UsaBiselSencillo = (parseInt(this.objPedido.UsaBiselSencillo) == 1) ? true : false;
            this.objPedido.OjoDerecho       = (parseInt(this.objPedido.OjoDerecho) == 1) ? true : false;
            this.objPedido.OjoIzquierdo     = (parseInt(this.objPedido.OjoIzquierdo) == 1) ? true : false;*/

            //this.ConfigLoad.ShowLoader = false;
        },

        Limpiar(){
            this.objPedido = {
				IdPedido: 0,
				IdCliente: 0,
				IdUsuario: 0,
				IdSubLinea: 0,
				IdArticuloWeb: 0,
				IdMaterial: 0,
				IdProteccion: 0,
				IdRecubrimiento: 0,
				IdArmazon: 0,
				IdBisel: 0,
				IdTipoLente: 0,
				Estatus: '',
				FolioCotizacion: '',
				FolioPedido: '',
				Fecha: '',
				Paciente: '',

				OjoDerecho: true,
				OdEsfera: '',
				OdCilindro: '',
				OdEje: '',
				OdAdicion: '',
				OdPrisma: '',
				OdDnp: '',
				OdAltMon: '',
				OdAltSeg: '',
				OdPosicion: '',

				OjoIzquierdo: true,
				OiEsfera: '',
				OiCilindro: '',
				OiEje: '',
				OiAdicion: '',
				OiPrisma: '',
				OiDnp: '',
				OiAltMon: '',
				OiAltSeg: '',
				OiPosicion: '',

				ReqTinte: '',
				IdColor: 0,
				Color: '',
				Tono: '',
				Coloracion: '',
				NumPar: 0,
			
				UsaBiselSencillo: false,
				IdBiselSencillo: 0,
				IdSubBisel: 0,
				NumGrapas: 0,

				Perforacion: '',
				
				ObservacionesGeneral: '',
				SubLinea: '',
				Articulo: '',
				Material: '',
				Proteccion: '',
				Recubrimiento: '',
				Armazon: '',
				AnguloPantoscopico: '',
				AnguloPanoramico: '',
				DistanciaVertice: '',
				DistanciaLectura: '',
				Iniciales: '',

				// PASO 3
				EnviaArmazon: false,
				MarcaArmazon: '',
				ColorArmazon: '',
				ModeloArmazon: '',
				EstadoArmazon: '',

				CambioForma: '',
				EscanearForma: '',
				MontarArmazon: '',
				AumentarArriba: '',
				AumentaAbajo: '',
				AumentaDerecho: '',
				Contorno: '',
				DBL: '',
				ED: '',
				B: '',
				A: '',
				AumentarMedida: 'NO',
				
				SubTotal: 0,
				Iva: 0,
				GranTotal: 0,
				FolioEnviado: '',
				Insertado: '',

                cliente: { Nombre: ''},
                tipolente: {Nombre: '', Proceso:0},
                sublinea: {Nombre: ''},
                articulo: {Nombre: ''},
                material: {Nombre: ''},
                proteccion: {Nombre: ''},
                recubrimiento: {Nombre: ''},
                armazon: {Nombre: ''},
                bisel: {Nombre: ''},
                color: {Nombre: ''},
            };
        }


    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>
        {
            
            this.Limpiar();
            console.log(obj);

            if(this.pOrigen != undefined && this.pOrigen != '') {
                if (obj != '') 
                {   
                    if(this.pOrigen != 'Form') {
                        this.objPedido.IdPedido = obj.IdPedido;
                        this.Recuperar();

                    }else {
                        //this.ConfigLoad.ShowLoader = true;
                        this.objPedido = obj;
                        this.setPedido();
                        this.ConfigLoad.ShowLoader = false;
                    }
                }
                else
                {
                    this.ConfigLoad.ShowLoader = false;
                }
            }else {
                this.ConfigLoad.ShowLoader = false;
            }
            
        });
    }
}
</script>
<style>
.dot {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
  background: rgb(87,87,92); 
  background: linear-gradient(180deg, rgba(87,87,92,1) 0%, rgba(207,207,207,1) 61%, rgba(254,254,254,1) 100%);
}
</style>